import { useEffect, useRef } from 'react';

const InactivityDetector = ({ onInactive }) => {
  const inactivityLimit = 3600000//20000// 3600000//; // 20 segundos para pruebas
  const lastActivity = useRef(Date.now());
  const deslogearRef = useRef(false);

  useEffect(() => {
    const handleActivity = () => {
      const Token = localStorage.getItem('token');
      
      if(Token){
        const currentTime = Date.now();
        lastActivity.current = currentTime;
        deslogearRef.current = false;
        localStorage.setItem('lastActivity', btoa(currentTime.toString()));
      }else{
        deslogearRef.current = true;
        onInactive();
      }
    };

    const events = ['mousedown', 'keypress', 'touchstart', 'touchmove'];
    events.forEach(event => window.addEventListener(event, handleActivity));

    const syncActivityAcrossTabs = () => {
      const storedTime = Number(atob(localStorage.getItem('lastActivity')));
      if (storedTime > lastActivity.current) {
        lastActivity.current = storedTime;
        deslogearRef.current = false;
      }
    };

    const checkInactivity = setInterval(() => {
      const logout = localStorage.getItem('logout');
      if(logout){
        deslogearRef.current = true;
        onInactive();
      }

      if (Date.now() - lastActivity.current > inactivityLimit && !deslogearRef.current) {
        deslogearRef.current = true;
        onInactive();
      }


    }, 10000); // Verificación cada 10 segundos

    window.addEventListener('storage', syncActivityAcrossTabs);

    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
      window.removeEventListener('storage', syncActivityAcrossTabs);
      clearInterval(checkInactivity);
    };
  }, [onInactive, inactivityLimit]);

  return null;
};

export default InactivityDetector;
